import { valueToLabel } from "./common";
import { getContrastTextColor } from "src/utils/color";

export type LabelType =
  | "name"
  | "value"
  | "percentage"
  | "name-value"
  | "name-percentage";

interface TreeMapCellLabelProps {
  name: string;
  value: number;
  displayValue?: string;
  total?: number;
  color: string;
  labelType?: LabelType;
  style?: React.CSSProperties;
}

export function TreeMapCellLabel({
  name,
  value,
  displayValue,
  total,
  color,
  labelType = "name",
  style,
}: TreeMapCellLabelProps) {
  const isNumeric = !Number.isNaN(value) && Number.isFinite(value);
  const percentage =
    isNumeric && total ? ((value / total) * 100).toFixed(1) + "%" : undefined;

  const getLabel = () => {
    switch (labelType) {
      case "value": {
        return displayValue || valueToLabel(value.toString());
      }
      case "percentage": {
        return percentage || valueToLabel(name);
      }
      case "name-value": {
        return displayValue
          ? `${valueToLabel(name)}: ${displayValue}`
          : valueToLabel(name);
      }
      case "name-percentage": {
        return percentage
          ? `${valueToLabel(name)}: ${percentage}`
          : valueToLabel(name);
      }
      case "name": {
        return valueToLabel(name);
      }
    }
  };

  return (
    <span
      className="trunc"
      style={{
        padding: "4px 8px",
        maxWidth: "calc(100% - 10px)",
        fontSize: 13,
        fontWeight: 500,
        letterSpacing: 0.3,
        fontVariant: "all-small-caps",

        color: getContrastTextColor(color),
        ...style,
      }}
    >
      {getLabel()}
    </span>
  );
}
